/**
 * PWA Badge Integration for Growtype Chat
 */
export const pwaBadge = () => {
    jQuery(document).on('typingAnimationComplete', function () {
        if (window.growtypePwa?.updateBadge && document.visibilityState !== 'visible') {
            window.growtypePwa.updateBadge(1);
        }
    });

    jQuery(document).on('growtypeChatContentRendered', function () {
        if (window.growtypePwa?.clearBadge && document.visibilityState === 'visible') {
            window.growtypePwa.clearBadge();
        }
    });
};
